import { Link } from "react-router-dom";
import moment from "moment";
import produce from "immer";

import EyeIcon from "../../assets/svg/EyeIconDetails.svg";

import { APPROVAL_FLOW_ACTIONS, APP_ROUTES, HH_MM_SS } from "../../../config/constants";
import { userStyles } from "../Styles/ApprovalRequestRecordStyle";
import { convertMinutesToHours } from "../../../utils/helperFunctions";
import { Grid, Typography } from "@material-ui/core";
import { APPROVAL_STATUS, ApprovalRecordFilterPopUpStateInterface, ApprovalRecordInitialStateInterface, IMPLEMENTATION_DATE, POS_NAME, POS_NO, REQUEST_DATE } from "../common/ApprovalRequestConstant";
import { isArrayValid, isEmptyOrNull, isNonEmptyObject } from "../../../utils/DataUtils";
import { generateElementIdentifier } from "utils/ApplicationUtils";
import { ELEMENT } from "components/common/App/app-constant";

export const getSingleUsePlasticListColumns = (userInfo: any) => {
  const classes = userStyles();

  const getApprovalStatusClassName = (approvalStatus: string) => {
    if (approvalStatus === APPROVAL_FLOW_ACTIONS.APPROVED) {
      return classes.approvedStatusStyle
    }

    if (approvalStatus === APPROVAL_FLOW_ACTIONS.REJECTED) {
      return classes.rejectedStatusStyle
    }
    return classes.pendingStatusStyle
  }

  return [
    { sortable: false, flex: 0.5, field: "posNo", headerName: "POS No", headerClassName: classes.headerStyle },
    { sortable: false, flex: 1, field: "storeName", headerName: "POS Name", headerClassName: classes.headerStyle },
    { sortable: false, flex: 0.5, field: "zoneName", headerName: "Zone No", headerClassName: classes.headerStyle },
    { sortable: false, flex: 0.5, field: "serviceType", headerName: "Service Type", headerClassName: classes.headerStyle },
    { sortable: false, flex: 1, field: "requester", headerName: "Requestor Name", headerClassName: classes.headerStyle },
    { sortable: false, flex: 1, field: "requestDate", headerName: "Request Date", headerClassName: classes.headerStyle },
    { sortable: false, flex: 1, field: "activationDate", headerName: "Implementation Date", headerClassName: classes.headerStyle },
    {
      sortable: false,
      flex: 0.5,
      field: "pendingDays",
      headerName: "Days Pending",
      headerClassName: classes.headerStyle,
      renderCell: (params: any) => {
        return params?.row?.pendingDays ?? "-";
      },
    },
    {
      sortable: false,
      flex: 1,
      field: "approvalStatus",
      headerName: "Approval Status",
      headerClassName: classes.headerStyle,
      renderCell: (params: any) => {
        const { row: { approvalStatus } } = params;
        return (
          <div className={getApprovalStatusClassName(approvalStatus)}>{`${approvalStatus || "n/a"}`}</div>
        );
      },
    },
    {
      sortable: false,
      flex: 0.5,
      field: "actions",
      headerName: "View",
      headerClassName: classes.headerStyle,
      renderCell: (params: any) => {
        const {
          row: { posNo, zoneName, serviceType, approvalStatus, requestedId, storeName },
        } = params;
        return (
          <Link
            to={{
              pathname: `${APP_ROUTES.APPROVAL_REQUESTS_DETAILS}`,
              search: `?posNo=${posNo}&zoneName=${zoneName}&serviceType=${serviceType}&approvalStatus=${approvalStatus}&requestedId=${requestedId}&storeName=${storeName}`,
            }}
          >
            <div className={classes.editIconStyle}>
              <img src={EyeIcon} alt="view config" />
            </div>
          </Link>
        );
      },
    },
  ];
};

export const designApprovalFlowRecordList = (record: any) => {
  if (isArrayValid(record)) {
    let recordData: any = record.map((item: any) => ({
      ...item,
      id: item?.requestId ?? "",
      requestedId: item?.requestId ?? "",
    }));
    return recordData;
  }
  return [];
};

export const design_approval_request_record_based_on_request_id_util = (data: any) => {
  const response_obj = { slots: {}, requestSlots: {}, } as any;
  if (isNonEmptyObject(data)) {
    Object.keys(data).forEach((slot_obj: any) => {
      if (!isEmptyOrNull(slot_obj) && !isEmptyOrNull(data[slot_obj])) {
        const { templateSlots } = data[slot_obj];
        if (isArrayValid(templateSlots)) {
          templateSlots.forEach((slot: any) => {
            if (!isEmptyOrNull(slot?.id)) {
              const reques_slot_obj = {
                ...slot,
                startTime: moment(slot.startTime, HH_MM_SS),
                endTime: moment(slot.endTime, HH_MM_SS),
                status: slot.status,
                time: `${moment(slot.startTime, HH_MM_SS).format("HH:mm")} - ${moment(slot.endTime, HH_MM_SS).format("HH:mm")}`,
                bufferTimeHours: convertMinutesToHours(slot.bufferTime).hours,
                bufferTimeMinutes: convertMinutesToHours(slot.bufferTime).minutes,
                orderCutOff: moment(slot.startTime, HH_MM_SS).subtract(convertMinutesToHours(slot.bufferTime).minutes, "m").format("HH:mm"),
              };

              if (slot_obj === "requestSlots") {
                if (response_obj.requestSlots[slot.day] !== undefined) {
                  response_obj.requestSlots[slot.day].push(reques_slot_obj);
                } else {
                  response_obj.requestSlots[slot.day] = [reques_slot_obj];
                }
              } else if (slot_obj === "slots") {
                if (response_obj.slots[slot.day] !== undefined) {
                  response_obj.slots[slot.day].push(reques_slot_obj);
                } else {
                  response_obj.slots[slot.day] = [reques_slot_obj];
                }
              }
            }
          });
        }
      }
    });
  }
  return response_obj;
};

interface ApprovalCongigurationDetailsHeadingInterface {
  classes: any;
  headingName: any;
  headingValue: any;
}
export const ApprovalCongigurationDetailsHeading = (props: ApprovalCongigurationDetailsHeadingInterface) => {
  const { classes, headingName, headingValue } = props;

  return (
    <Grid item className={classes.approverDetailsMainHeadingDivStyle}>
      <Grid container spacing={0}>
        <Grid item xs={12} className={classes.approverDetailsHeadingDivStyle}>
          <Typography data-testid={generateElementIdentifier({ key: headingName, element: ELEMENT.TYPOGRAPHY })} className={classes.commonApproverDetailsHeadingSpanStyle}>{`${headingName}`}</Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography data-testid={generateElementIdentifier({ key: headingValue, element: ELEMENT.TYPOGRAPHY })} className={classes.approverDetailsHeadingValueSpanStyle}>{`${headingValue ?? "-"}`}</Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export const desgin_approval_flow_record_list = (approvalRecordState: ApprovalRecordInitialStateInterface, record_data: any) => {
  let newApprovalRecordState: ApprovalRecordInitialStateInterface = produce(approvalRecordState, (draft: ApprovalRecordInitialStateInterface) => {
    let recordListData = [] as any;
    if (isArrayValid(record_data?.content)) {
      record_data.content.forEach((record: any) => {
        let obj = { ...record };
        obj.id = record?.requestId ?? "";
        obj.requestedId = record?.requestId ?? "";
        recordListData.push(obj);
      });
    }
    draft.isLoading = false;
    draft.pageNumber = record_data.pageNumber;
    draft.pageSize = record_data.size;
    draft.maxRecordPresent = record_data.totalSize;
    draft.recordList = [...recordListData];
  });
  return newApprovalRecordState;
};

export const handle_open_filter_pop_up_utils = (event: any, appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface, open: any, anchorName: any) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    draft.loading = open;
    if (!open) {
      draft.openPosNoPopUp = false;
      draft.openPosNamePopUp = false;
      draft.openApprovalStatusPopUp = false;
      draft.openRequestDatePopUp = false;
      draft.openImplementationDatePopUp = false;
    }

    if (open) {
      switch (anchorName) {
        case POS_NO:
          draft.openPosNoPopUp = true;
          break;
        case POS_NAME:
          draft.openPosNamePopUp = true;
          break;
        case APPROVAL_STATUS:
          draft.openApprovalStatusPopUp = true;
          break;
        case REQUEST_DATE:
          draft.openRequestDatePopUp = true;
          break;
        case IMPLEMENTATION_DATE:
          draft.openImplementationDatePopUp = true;
          break;
      }
    }

    draft.anchorEl = null;
    if (!isEmptyOrNull(event?.currentTarget)) {
      draft.anchorEl = event.currentTarget;
    }

    draft.filterByHeader = anchorName;
    draft.posNoNameSearchText = "";
    draft.posNoNameRecord = [];
    draft.posNoNameFilteredRecord = [];
  });
  return newAppFilterPopUpObj;
};

export const clear_all_filter_utils = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    draft.loading = false;
    draft.isDataFetched = false;
    draft.openPosNoPopUp = false;
    draft.openPosNamePopUp = false;
    draft.openApprovalStatusPopUp = false;
    draft.openRequestDatePopUp = false;
    draft.openImplementationDatePopUp = false;
    draft.anchorEl = null;
    draft.filterByHeader = "";
    draft.posNoNameSearchText = "";
    draft.posNoNameRecord = [];
    draft.posNoNameFilteredRecord = [];
    draft.posNoFilter = [];
    draft.posNameFilter = [];
    draft.statusFilter = [];
    draft.requestDatelabel = "";
    draft.requestDate = { startDate: "", endDate: "" };
    draft.implementationDatelabel = "";
    draft.implementationDate = { startDate: "", endDate: "" };
  });
  return newAppFilterPopUpObj;
};

export const _handle_design_mapped_pos_no_name_record_util = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface, listData: any, anchorName: any) => {
  let newAppFilterPopUpObj: any = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    listData = listData.map((value: any) => ({ ...value, isChecked: false, hide_row: false }));
    draft.loading = false;
    if (!isEmptyOrNull(draft?.filterByHeader)) {
      if (draft.filterByHeader === POS_NO && isArrayValid(draft?.posNoFilter)) {
        listData = listData.map((value: any) =>
          !isEmptyOrNull(value?.id) && draft.posNoFilter.findIndex((item: any) => item.id === value.id) > -1 ? { ...value, isChecked: true } : value
        );
      } else if (draft.filterByHeader === POS_NAME && isArrayValid(draft?.posNameFilter)) {
        listData = listData.map((value: any) =>
          !isEmptyOrNull(value?.id) && draft.posNameFilter.findIndex((item: any) => item.id === value.id) > -1 ? { ...value, isChecked: true } : value
        );
      } else if (draft.filterByHeader === APPROVAL_STATUS && isArrayValid(draft?.statusFilter)) {
        listData = listData.map((value: any) =>
          !isEmptyOrNull(value?.id) && draft.statusFilter.findIndex((item: any) => item === value.id) > -1 ? { ...value, isChecked: true } : value
        );
      }
    }
    draft.posNoNameRecord = listData;
    draft.posNoNameFilteredRecord = listData;
  });
  return newAppFilterPopUpObj;
};

export const _handle_design_record_based_on_search_util = (data_list: any, searchText: any, current_list: any) => {
  let result_list = [] as any;
  let selected_list = current_list.filter((list: any) => list.isChecked === true);

  if (isArrayValid(data_list)) {
    if (!isEmptyOrNull(searchText)) {
      const searchTextLower = searchText.toLowerCase();
      const filtered_list_data: any[] = data_list.filter((item: any) => {
        const { posNo, posName, value } = item; // Destructure for cleaner access
        const includesSearchText = (text: string | undefined): boolean =>
          !!text && text.toLowerCase().includes(searchTextLower);
        return (
          includesSearchText(posNo) ||
          includesSearchText(posName) ||
          includesSearchText(value)
        );
      });
      result_list = [...filtered_list_data];
    } else {
      result_list = [...data_list];
    }
  }

  let filtered_list = JSON.parse(JSON.stringify(result_list));
  if (isArrayValid(selected_list)) {
    selected_list.forEach((selected: any) => {
      if (!isEmptyOrNull(selected?.id) && filtered_list.findIndex((item: any) => item.id === selected.id) === -1) {
        let selected_copy = JSON.parse(JSON.stringify(selected));
        selected_copy.hide_row = true;
        filtered_list.push(selected_copy);
      } else {
        let index = filtered_list.findIndex((item: any) => item.id === selected.id);
        filtered_list[index].isChecked = true;
      }
    });
  }
  const returnObject = { listData: filtered_list };
  return returnObject;
};

export const handle_check_box_click_utils = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface, checked: any, listIndex: any, filterType: any) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    draft.posNoNameFilteredRecord[listIndex].isChecked = checked;
    if (filterType !== undefined && filterType !== "") {
      if (checked) {
        switch (filterType) {
          case POS_NO:
            draft.posNoFilter.push(draft.posNoNameFilteredRecord[listIndex]);
            break;
          case POS_NAME:
            draft.posNameFilter.push(draft.posNoNameFilteredRecord[listIndex]);
            break;
          case APPROVAL_STATUS:
            draft.statusFilter.push(draft.posNoNameFilteredRecord[listIndex].id);
            break;
        }
      } else {
        switch (filterType) {
          case POS_NO:
            draft.posNoFilter = draft.posNoFilter.filter((obj: any) => obj.id !== draft.posNoNameFilteredRecord[listIndex].id);
            break;
          case POS_NAME:
            draft.posNameFilter = draft.posNameFilter.filter((obj: any) => obj.id !== draft.posNoNameFilteredRecord[listIndex].id);
            break;
          case APPROVAL_STATUS:
            draft.statusFilter = draft.statusFilter.filter((obj: any) => obj !== draft.posNoNameFilteredRecord[listIndex].id);
            break;
        }
      }
    }
  });
  return newAppFilterPopUpObj;
};

export const handle_reset_pos_no_name_filter_pop_up_utils = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface, anchorName: any) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    let listData = appFilterPopUpObj.posNoNameRecord.map((value: any) => ({ ...value, isChecked: false }));
    draft.posNoNameSearchText = "";
    draft.posNoNameRecord = listData;
    draft.posNoNameFilteredRecord = listData;
    if (!isEmptyOrNull(anchorName)) {
      switch (anchorName) {
        case POS_NO:
          draft.posNoFilter = [];
          break;
        case POS_NAME:
          draft.posNameFilter = [];
          break;
        case APPROVAL_STATUS:
          draft.statusFilter = [];
          break;
      }
    }
  });
  return newAppFilterPopUpObj;
};

export const handle_close_pop_and_fetch_data = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    draft.loading = false;
    draft.isDataFetched = true;
    draft.openPosNoPopUp = false;
    draft.openPosNamePopUp = false;
    draft.openApprovalStatusPopUp = false;
    draft.openRequestDatePopUp = false;
    draft.openImplementationDatePopUp = false;
    draft.anchorEl = null;
    draft.filterByHeader = "";
    draft.posNoNameSearchText = "";
    draft.posNoNameRecord = [];
    draft.posNoNameFilteredRecord = [];
  });
  return newAppFilterPopUpObj;
};

export const design_filter_object_from_header = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface) => {
  const serviceTypeFilterObject = {} as any;

  if (isEmptyOrNull(appFilterPopUpObj)) {
    return serviceTypeFilterObject;
  }

  if (isArrayValid(appFilterPopUpObj?.posNoFilter)) {
    serviceTypeFilterObject.posNos = [];
    appFilterPopUpObj.posNoFilter.forEach((arr: any) => {
      serviceTypeFilterObject.posNos.push(arr.posNo);
    });
  }

  if (isArrayValid(appFilterPopUpObj?.posNameFilter)) {
    serviceTypeFilterObject.posNames = [];
    appFilterPopUpObj.posNameFilter.forEach((arr: any) => {
      serviceTypeFilterObject.posNames.push(arr.posName);
    });
  }

  if (isArrayValid(appFilterPopUpObj?.statusFilter)) {
    serviceTypeFilterObject.statuses = [...appFilterPopUpObj.statusFilter];
  }

  if (!isEmptyOrNull(appFilterPopUpObj?.requestDatelabel)) {
    const date_range = appFilterPopUpObj.requestDatelabel.split(" - ");
    if (isArrayValid(date_range)) {
      serviceTypeFilterObject.requestDate = {} as any;
      serviceTypeFilterObject.requestDate.startDate = date_range[0];
      serviceTypeFilterObject.requestDate.endDate = date_range[1];
    }
  }

  if (!isEmptyOrNull(appFilterPopUpObj?.implementationDatelabel)) {
    const date_range = appFilterPopUpObj.implementationDatelabel.split(" - ");
    if (isArrayValid(date_range)) {
      serviceTypeFilterObject.implementationDate = {} as any;
      serviceTypeFilterObject.implementationDate.startDate = date_range[0];
      serviceTypeFilterObject.implementationDate.endDate = date_range[1];
    }
  }

  return serviceTypeFilterObject;
};

export const update_filter_date_based_on_value = (appFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface, anchorName: any, startDate: any, endDate: any) => {
  let newAppFilterPopUpObj: ApprovalRecordFilterPopUpStateInterface = produce(appFilterPopUpObj, (draft: ApprovalRecordFilterPopUpStateInterface) => {
    if (!isEmptyOrNull(anchorName)) {
      draft.isDataFetched = false;
      if (anchorName === REQUEST_DATE) {
        draft.openRequestDatePopUp = false;
        draft.requestDatelabel = "";
        draft.requestDate = { startDate: "", endDate: "" };
        if (startDate !== "" && endDate !== "") {
          draft.requestDatelabel = `${startDate} - ${endDate}`;
          draft.requestDate.startDate = startDate;
          draft.requestDate.endDate = endDate;
          draft.isDataFetched = true;
        }
      } else if (anchorName === IMPLEMENTATION_DATE) {
        draft.openImplementationDatePopUp = false;
        draft.implementationDatelabel = "";
        draft.implementationDate = { startDate: "", endDate: "" };
        if (startDate !== "" && endDate !== "") {
          draft.implementationDatelabel = `${startDate} - ${endDate}`;
          draft.implementationDate.startDate = startDate;
          draft.implementationDate.endDate = endDate;
          draft.isDataFetched = true;
        }
      }

      if (isArrayValid(draft?.posNoFilter) || isArrayValid(draft?.posNameFilter) || isArrayValid(draft?.statusFilter)) {
        draft.isDataFetched = true;
      }
    }
  });
  return newAppFilterPopUpObj;
};

export const get_class_name_based_on_status = (slot: any, classes: any, slot_data_object_key: any) => {
  if (isEmptyOrNull(slot?.slotAction)) {
    return "";
  }

  switch (slot.slotAction) {
    case "UPDATE":
      return classes.updatededSlot;
    case "DELETE":
      return classes.deletedSlot;
    case "ADD":
      if (!isEmptyOrNull(slot_data_object_key) && slot_data_object_key !== "slots") {
        return classes.addedSlot;
      }
      return "";
  }
};
